import CustomersResource from 'flow/api/customers';
import UserContactSchemaResource from 'flow/api/usercontactschema';

import { httpGetErrorDispatcher } from 'flow/actions/app-actions';

import Actions from 'flow/actions';

export const fetchLoggedInCustomer = (extensionKey) => (dispatch) => {
    return new Promise((resolve, reject) => {
        CustomersResource.getLoggedInCustomer({
            onResult(json) {
                dispatch(receiveLoggedInCustomer(json, extensionKey));
                resolve(json);
            },

            onError: (error) => {
                httpGetErrorDispatcher(dispatch);
                reject(error);
            },

            onClientError: (error) => {
                reject(error);
            },
        });
    });
};

export const fetchCustomerContactFields = (dispatch) => {
    return new Promise((resolve, reject) => {
        UserContactSchemaResource.getUserContactSchemaDefinition({
            onResult(json) {
                dispatch(receiveCustomerContactFields(json));
                resolve(json);
            },

            onError: (error) => {
                httpGetErrorDispatcher(dispatch);
                reject(error);
            },

            onClientError: (error) => {
                reject(error);
            },
        });
    });
};

const receiveCustomerContactFields = (response) => ({
    type: Actions.RESULT_CUSTOMER_CONTACT_FIELDS,
    data: response,
});

const receiveLoggedInCustomer = (customer, extensionKey) => ({
    type: Actions.RESULT_CUSTOMER,
    key: extensionKey,
    data: customer,
});
